module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_vote.821b2.png";